module.exports = "../static/media/banner.a7c06c8c.png";